<template>
    <div class="directory-embedded-list">
            <div class="directory-list-toolbar">
                <div class="directory-search">
                    <i class="fa-solid fa-magnifying-glass"></i>
                    <input type="text" :placeholder="$t('Search Office here...')" class="form-control" :value="officeSearch" @input="searchOffice($event.target.value)"/>
                </div>
                <div class="directory-pagination" v-if="officeList.totalDocs">
                <Pagination
                    :paginationDetails="{totalPages : officeList.totalPages, page : officeList.page}"
                    :changePage="ChangePage" 
                ></Pagination>
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="table-responsive">
                <table class="table table-striped directory-table">
                    <thead>
                        <tr>
                            <th>{{ $t('Name') }}</th>
                            <th>{{ $t('Region') }}</th>
                            <th>{{ $t('Created At') }}</th>
                            <th class="directory-status-col">{{ $t('Status') }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody class="text-capitalize">
                        <tr v-if="officeList.totalDocs==0">
                            <td class="text-center directory-empty-state" colspan="5">{{ $t('No Data Found') }}</td>
                        </tr>
                        <tr v-for="(item, key) in officeList.docs" :key="item._id || key" :class="{ 'is-highlighted': item._id === highlightedOfficeId }">
                            <td class="directory-user-name">{{item.officeName}}</td>
                            <td>{{item.regionId.regionName}}</td>
                            <td>{{formatDate(item.createdAt)}}</td>
                            <td class="directory-status-col">
                                <span class="badge bg-primary text-white" v-if="item.status">{{ $t('Active') }}</span>
                                <span class="badge bg-danger text-white" v-else>{{ $t('Inactive') }}</span>
                            </td>
                            <td class="directory-table__actions">
                                <button class="directory-icon-btn directory-icon-btn--edit" 
                                @click="AppendData({_id : item._id, officeName : item.officeName, regionId : item.regionId._id})" 
                                data-bs-toggle="modal" 
                                data-bs-target="#UpdateOfficeModal" 
                                :title="$t('Edit')">
                                    <i class="fa-solid fa-pen"></i>
                                </button>
                                <button class="directory-icon-btn directory-icon-btn--status" :title="item.status ? $t('Deactivate Office') : $t('Activate Office')" @click="ChangeStatus(item)"><i class="fa-solid fa-lock"></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Pagination from '@/components/layout/Pagination.vue'
import {ReformatDate} from '@/helpers/utilities.js'
import {confirmDirectoryStatusChange} from '@/helpers/directoryStatusConfirm.js'
export default {
    name : 'OfficeList',
    components : {
        Pagination
    },
    data(){
        return{
            timer : null
        }
    },
    methods : {
        ...mapActions(['GetOfficeList','UpdateOfficeStatus','AppendOfficeUpdateData','ClearOfficeHighlight']),
        ChangePage (page){
            this.ClearOfficeHighlight()
            this.GetOfficeList({search : this.officeSearch, page : page}).catch()
        },
        timerSetter(typed, callback, seachEmpty = false){
            const self = this
            if(!seachEmpty){
                if(!typed){
                return
                }
            }
            
            if(self.timer){
                clearTimeout(self.timer)
                self.timer = null
            }

            self.timer = setTimeout(callback,700)
        },
        searchOffice(search){
            const self = this
            self.ClearOfficeHighlight()
            self.timerSetter(search,function(){
                self.GetOfficeList({search : search, page : 1}).catch()
            },true)
        },
        formatDate(value){
            return ReformatDate(value)
        },
        AppendData(data){
            this.AppendOfficeUpdateData(data)
        },
        ChangeStatus(office){
            return confirmDirectoryStatusChange(this, {
                entityName: 'Office',
                itemName: office.officeName,
                isActive: Boolean(office.status),
                onConfirm: () => this.UpdateOfficeStatus(office._id),
                successDescriptionBuilder: ({ completedAction, highlightedName, nextStatus }) => `${highlightedName} office has been ${completedAction.toLowerCase()} successfully. The office status is now ${nextStatus}.`,
                errorMessage: 'Unable to update office status.'
            })
        }
    },
    computed : mapGetters(['officeList','officeSearch','highlightedOfficeId'])
    
}
</script>
